import { css } from 'styled-components'

export default css`
  #af-smart-banner {
    z-index: 999 !important;
  }
`
